/* This file will handle my API i think to tie front/backend */

import axios from 'axios'

const baseUrl = "https://fullstack-todoapp-publicversion-backend.onrender.com"

const getAllToDo = (setToDo) => {
    axios
    .get(baseUrl)
    .then(({data}) => {
        console.log('data --> ', data);
        setToDo(data)
    })
}

/** add text to be added, settext and settodo */
const addToDo = (text, setText, setToDo) => {
    axios
    .post(`${baseUrl}/save`, {text})
    .then((data) => {
        console.log(data);
        setText("") /*clearing the text field with this line */
        getAllToDo(setToDo) /**fetching all todos including new one */
    })
    .catch((err) => console.log(err))
}

/** update to do items */
const updateToDo = (toDoId, text, setToDo, setText, setIsUpdating) => {
    axios
    .post(`${baseUrl}/update`, {_id: toDoId, text})
    .then((data) => {
        setText("") /*clearing the text field with this line */
        setIsUpdating(false)
        getAllToDo(setToDo) /**fetching all todos including new one */
    })
    .catch((err) => console.log(err))
}

/** delete to do items */
const deleteToDo = (_id, setToDo) => {
    axios
    .post(`${baseUrl}/delete`, {_id })
    .then((data) => {
        console.log(data)
        getAllToDo(setToDo)
    })
    .catch((err) => console.log(err))
}

export {getAllToDo, addToDo, updateToDo, deleteToDo}